<div class="row h-100 justify-content-md-center align-items-center">
	<div class="d-none d-lg-block col-md-auto">
		<div class="logo-section">
			<img class="logo-image mx-auto d-block" src="assets/images/Logo_with_text.png"
				alt="Open Credential Publisher" />
		</div>
	</div>
	<div class="col-auto login-body">
		<div class="row">
			<section class="login-form">
                <h2>
                    Login is required to access this area
                </h2>
                <div>
                    <button type="button" class="btn btn-primary" (click)="login()">Login</button>
                    <button type="button" class="btn btn-default" (click)="goback()">Back</button>
                </div>
            </section>
		</div>
	</div>
</div>
